import * as React from 'react';
import SisImport from '.';
import OneRosterFileUpload from '../OneRoster';
import OneRosterStaffRecordsMatching from '../SisFieldMatching/OneRosterStaffRecordsMatching';
import OneRosterSchoolMap from '../OneRoster/SchoolMapping';
import SisStaffRecordsDefineCodes from '../SisDefineCodes/SisStaffRecordsDefineCodes';
import { IntegrationContext } from '../../utils/context';
import apiClient from '../../utils/apiClient';
import { Spin } from 'antd';
import ResetConfigModalWrapper from '../ResetConfig';
import { featureFlags } from '../../utils/featureFlags';
import MainTemplate from '../Shell/MainTemplate';
import OneRosterStartImport from '../SisStartImport/OneRosterStartImport';
import OnerosterStaffSyncSettings from '../SisSyncSettings/OnerosterStaffSyncSettings';

export const OneRosterImportSteps = () => {
  if (featureFlags['feature.dataIngest.oneRosterImportSettingsPage']) {
    return [
      { title: 'Header mapping', content: OneRosterStaffRecordsMatching, path: '/import-wizard/oneroster/staff/header-mapping' },
      { title: 'Role mapping', content: SisStaffRecordsDefineCodes, path: '/import-wizard/oneroster/staff/define-code' },
      { title: 'Import rules', content: OnerosterStaffSyncSettings, path: '/import-wizard/oneroster/staff/import-rule' },
      { title: 'Test/Start import', content: OneRosterStartImport, path: '/import-wizard/oneroster/staff/start-import' },
    ];
  }
  return [
    { title: 'Upload file', content: OneRosterFileUpload, path: '/import-wizard/oneroster/staff/upload-file' },
    { title: 'School mapping', content: OneRosterSchoolMap, path: '/import-wizard/oneroster/staff/school-map' },
    { title: 'Header mapping', content: OneRosterStaffRecordsMatching, path: '/import-wizard/oneroster/staff/header-mapping' },
    { title: 'Role mapping', content: SisStaffRecordsDefineCodes, path: '/import-wizard/oneroster/staff/define-code' },
    { title: 'Import rules', content: OnerosterStaffSyncSettings, path: '/import-wizard/oneroster/staff/import-rule' },
    { title: 'Test/Start import', content: OneRosterStartImport, path: '/import-wizard/oneroster/staff/start-import' },
  ];
};

const OneRosterImportComponent = (): React.ReactElement => {
  const { districtAlias, userFullName } = React.useContext(IntegrationContext);
    const [showResetConfig, setShowResetConfig] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
  
    const fetchConnectionStatus = React.useCallback(async () => {
      try {
        const { data: meta } = await apiClient.get(`/data-ingest/sis/tenant-meta`);
        if (meta && meta.sisIntegration !== 'oneroster' && meta.clientId) {
          setShowResetConfig(true);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }, [districtAlias]);
  
    React.useEffect(() => {
      fetchConnectionStatus();
    }, [fetchConnectionStatus]);
  
    if (loading) {
      return (
        <MainTemplate title="" titleClassName="sftpSettingsTitle" titleTestId="sftpSettingsTitle">
          <div className="spinner" data-testid="loading-spinner">
            <Spin size="large" />
          </div>
        </MainTemplate>
      );
    }
  
    if (showResetConfig) {
      return (
        <MainTemplate title="" titleClassName="sftpSettingsTitle" titleTestId="sftpSettingsTitle">
          <ResetConfigModalWrapper
            author={userFullName}
            integrationType={'oneRoster'}
            setTTLFlag={featureFlags['feature.dataIngest.reset.setTTL']}
            setShowResetConfig={setShowResetConfig}
          />
        </MainTemplate>
      );
    }
  return <SisImport steps={OneRosterImportSteps()} />;
};

export default OneRosterImportComponent;
